import { observer } from 'mobx-react-lite'
import { type UploadBarViewModel } from '@/features/documents/UploadBarViewModel'
import { type Workspace } from '@/features/iam/workspaces/Workspace'
import { UploadBar } from '@/features/documents/components/DocumentRoot/UploadBar'

export interface UploadBarContainerProps {
  vm: UploadBarViewModel
  targetWorkspace: Workspace
}

export const UploadBarContainer = observer(function UploadBarContainer({
  vm,
  targetWorkspace,
}: UploadBarContainerProps) {
  return (
    <UploadBar
      hidden={vm.hidden}
      autoDismiss={vm.autoDismiss}
      dragging={vm.dragging}
      uploading={vm.uploading}
      currentlyUploadingFileName={vm.currentlyUploadingFile?.name}
      docsPendingUpload={vm.docsPendingUpload}
      remainingCount={vm.uploadQueueFiles.length}
      uploadPercent={vm.uploadPercent}
      resolved={vm.resolved}
      successUploadCount={vm.successUploads.length}
      firstSuccessUploadName={vm.successUploads[0]?.file.name}
      targetWorkspaceName={targetWorkspace.name}
      onClose={vm.setHidden}
    />
  )
})
